import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.gstechnovos.jexonplastech.pages.HomePage as _org_gstechnovos_jexonplastech_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Jexon Plastech"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _org_gstechnovos_jexonplastech_pages_HomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("about-image", org.gstechnovos.jexonplastech.styles.AboutImageStyle)
        ctx.theme.registerStyle("about-text", org.gstechnovos.jexonplastech.styles.AboutTextStyle)
        ctx.theme.registerStyle("skill-bar-progress", org.gstechnovos.jexonplastech.styles.SkillBarProgress)
        ctx.theme.registerStyle("achievement", org.gstechnovos.jexonplastech.styles.AchievementStyle)
        ctx.theme.registerStyle("back-to-top", org.gstechnovos.jexonplastech.styles.BackToTop)
        ctx.theme.registerStyle("input", org.gstechnovos.jexonplastech.styles.InputStyle)
        ctx.theme.registerStyle("navigation-item", org.gstechnovos.jexonplastech.styles.NavigationItemStyle)
        ctx.theme.registerStyle("logo", org.gstechnovos.jexonplastech.styles.LogoStyle)
        ctx.theme.registerStyle("social-link", org.gstechnovos.jexonplastech.styles.SocialLinkStyle)
        ctx.theme.registerStyle("main-button", org.gstechnovos.jexonplastech.styles.MainButtonStyle)
        ctx.theme.registerStyle("main-image", org.gstechnovos.jexonplastech.styles.MainImageStyle)
        ctx.theme.registerStyle("portfolio-section", org.gstechnovos.jexonplastech.styles.PortfolioSectionStyle)
        ctx.theme.registerStyle("portfolio-arrow-icon", org.gstechnovos.jexonplastech.styles.PortfolioArrowIconStyle)
        ctx.theme.registerStyle("service-card", org.gstechnovos.jexonplastech.styles.ServiceCardStyle)
        org.gstechnovos.jexonplastech.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.gstechnovos.jexonplastech.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
